/**
 * @module JUF
 * @description Javascript Utility Framework — authentication, communication (SMS/email),
 * and payment processing via the Sonatel Apigee platform.
 *
 * **Recommended:** Use subpath imports for smaller bundles:
 * ```js
 * import { Authentication } from '@sonatel-os/juf/auth';
 * import { Communication } from '@sonatel-os/juf/communication';
 * import { Payment } from '@sonatel-os/juf/payment';
 * import { JufError, ValidationError } from '@sonatel-os/juf/core';
 * ```
 *
 * The root import below is maintained for backward compatibility.
 * @deprecated Use subpath imports instead — this flat export will be removed in v2.0.0.
 */

import { Authentication } from './src/auth/index.js';
import { Communication } from './src/communication/index.js';
import { Payment } from './src/payment/index.js';
import { JufError, ValidationError, AuthenticationError, ExternalServiceError } from './src/core/index.js';
import { logger } from '@sonatel-os/juf-xpress-logger';

const authentication = Authentication.init();
const communication = Communication.init({ authService: authentication });
const payment = Payment.init({ authService: authentication });

export {
  logger,
  authentication,
  communication,
  payment,
  Authentication,
  Communication,
  Payment,
  JufError,
  ValidationError,
  AuthenticationError,
  ExternalServiceError,
};
